import React, { FormEvent } from "react";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES_CONFIG } from "src/constants/routesConfig";
import { useHistory } from "src/context";

const BackButton: React.FC = () => {
  const navigate = useNavigate();
  const { history } = useHistory();
  const location = useLocation();

  const handleBackButtonClick = (e: FormEvent) => {
    e.preventDefault();

    const hasPrevPage = history.length >= 2;
    const isVerificationPage = location.pathname === ROUTES_CONFIG.userEmailVerification.path;

    if (!hasPrevPage || isVerificationPage) {
      navigate(ROUTES_CONFIG.home.path);
      return;
    }

    const previousPath = history[history.length - 2];
    const currentPath = location.pathname;
    const isSamePath = previousPath === currentPath;

    if (!isSamePath) {
      navigate(-1);
      return;
    }

    const differentPathIndex = history.slice(0, -1).findLastIndex((path) => path !== currentPath);
    const hasDifferentPath = differentPathIndex >= 0;
    const targetPath = hasDifferentPath ? history[differentPathIndex] : ROUTES_CONFIG.home.path;

    navigate(targetPath);
  };

  return (
    <button
      className="inline-flex items-center justify-center gap-2 rounded-lg border border-secondary-300 bg-white px-6 py-3 text-sm font-semibold text-secondary-700 transition-all duration-200 hover:bg-secondary-50 hover:border-secondary-400 focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      onClick={handleBackButtonClick}
    >
      <ArrowLeft className="h-4 w-4" />
      Back
    </button>
  );
};

export { BackButton };
